export default __webpack_public_path__ + "static/media/dyeing8.34edba1f.png";